import { render, staticRenderFns } from "./EmployeeRegistrationStatus.vue?vue&type=template&id=ee8a4a60&scoped=true&"
import script from "./EmployeeRegistrationStatus.vue?vue&type=script&lang=js&"
export * from "./EmployeeRegistrationStatus.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeRegistrationStatus.vue?vue&type=style&index=0&id=ee8a4a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8a4a60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAutocomplete,VBtn,VCol,VDataTable,VIcon,VRow,VTextField,VToolbar,VToolbarTitle})
